import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';

import { messages } from '../messages';
import style from './style.module.less';

/**
 * AccessCodeSection component for entering access codes
 * @param {object} props
 * @param {boolean} [props.needsAccessCode] - Whether access code is needed
 * @param {(checked: boolean) => void} [props.onNeedsAccessCodeChange] - Callback when access code requirement changes
 * @param {string} [props.accessCode] - The access code value
 * @param {(code: string) => void} [props.onAccessCodeChange] - Callback when access code changes
 * @returns {React.ReactElement} The AccessCodeSection component
 */
export const AccessCodeSection = ({
  needsAccessCode = false,
  onNeedsAccessCodeChange = noop,
  accessCode = '',
  onAccessCodeChange = noop,
}) => {
  return (
    <div className={style['access-code-section']}>
      <Checkbox checked={needsAccessCode} onChange={onNeedsAccessCodeChange}>
        <FormattedMessage {...messages.driverNeedsAccessCodeLabel} />
      </Checkbox>
      {needsAccessCode && <Input className={style.accessCodeInput} onChange={onAccessCodeChange} value={accessCode} />}
    </div>
  );
};
